import * as React from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import MaskedInput from 'react-text-mask';
import { Controller, useFormContext, useController, get } from 'react-hook-form';

function PostalCodeFormat(props) {
    const { inputRef, ...other } = props;
    const pipe = (conformedValue) => {
        return conformedValue.toUpperCase();
    };
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[A-Z]/i, /\d/, /[A-Z]/i, ' ', /\d/, /[A-Z]/i, /\d/]}
            pipe={pipe}
            showMask={false}
        />
    );
}

function SinFormat(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]}
            showMask={false}
        />
    );
}
export const TextFieldCustom = ({ ...props }) => {
    const { meta } = useController(props);
    const { control, formState } = useFormContext();
    const error = get(formState.errors, props.name);
    const errorText = meta.invalid ? error.message : '';
    let inputProps = {};

    if (props.prefix) {
        inputProps = {
            startAdornment: <InputAdornment position="start">{props.prefix}</InputAdornment>,
            readOnly: props?.readOnly
        };
    }

    if (props.phone) {
        return (
            <Controller
                {...props}
                as={
                    <NumberFormat
                        format="(###) ### ####"
                        customInput={TextField}
                        defaultValue={props.defaultValue}
                    />
                }
                fullWidth
                variant="outlined"
                size="small"
                control={control}
                helperText={errorText ? errorText : props.helperText}
                error={!!errorText}
                defaultValue={props.defaultValue}
            />
        );
    }
    if (props.money) {
        return (
            <Controller
                {...props}
                as={
                    <NumberFormat
                        thousandSeparator={true}
                        prefix={'$ '}
                        customInput={TextField}
                        onValueChange={props.onChange}
                    />
                }
                fullWidth
                variant="outlined"
                size="small"
                control={control}
                helperText={errorText ? errorText : props.helperText}
                error={!!errorText}
                InputProps={inputProps}
                defaultValue={props.defaultValue}
            />
        );
    }
    if (props.number) {
        return (
            <Controller
                {...props}
                as={
                    <NumberFormat
                        thousandSeparator={false}
                        customInput={TextField}
                        onValueChange={props.onChange}
                        {...props.isAllowed}
                    />
                }
                fullWidth
                variant="outlined"
                size="small"
                control={control}
                helperText={errorText ? errorText : props.helperText}
                error={!!errorText}
                InputProps={inputProps}
                defaultValue={props.defaultValue}
            />
        );
    }
    if (props.postalcode) {
        return (
            <Controller
                {...props}
                as={TextField}
                fullWidth
                variant="outlined"
                size="small"
                control={control}
                helperText={errorText ? errorText : props.helperText}
                error={!!errorText}
                InputProps={{
                    inputComponent: PostalCodeFormat
                }}
                defaultValue={props.defaultValue}
            />
        );
    }
    if (props.sin) {
        return (
            <Controller
                {...props}
                as={TextField}
                fullWidth
                variant="outlined"
                size="small"
                control={control}
                helperText={errorText ? errorText : props.helperText}
                error={!!errorText}
                InputProps={{
                    inputComponent: SinFormat
                }}
                defaultValue={props.defaultValue}
            />
        );
    }
    return (
        <Controller
            {...props}
            as={TextField}
            fullWidth
            variant="outlined"
            size="small"
            control={control}
            helperText={errorText ? errorText : props.helperText}
            error={!!errorText}
            InputProps={inputProps}
            defaultValue={props.defaultValue}
        />
    );
};
